import React, { useState } from "react";
import HamburgerMenu from "./HamburgerMenu";

const TermsOfService = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <div className="min-h-screen bg-black text-white font-[Montserrat] pt-24 px-5 pb-12">
      {/* Header (Hamburger only) */}
      <div
        className="flex justify-end items-center px-6 py-2 relative z-20"
        style={{
          background: "rgba(0,0,0,0.0)",
          boxShadow: "none",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1000,
        }}
      >
        <HamburgerMenu menuOpen={menuOpen} toggleMenu={toggleMenu} />
      </div>

      {/* Terms Content */}
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold mb-2">Terms of Service</h1>
        <p className="text-gray-400 text-base mb-8">Effective Date: June 19, 2025</p>

        <Section title="1. Use of Our Service">
          <p>You must be at least 13 years old to use the platform. If you are under 18, you may only use the platform with the consent of a parent or legal guardian.</p>
          <p>You agree to use the platform only for lawful purposes and in accordance with these Terms.</p>
        </Section>

        <Section title="2. Account Registration">
          <p>To use certain features, you must create an account. You agree to provide accurate and complete information and to keep your account credentials confidential. You are responsible for all activity that occurs under your account.</p>
          <p>We reserve the right to suspend or terminate any account that we believe violates these Terms or is used inappropriately.</p>
        </Section>

        <Section title="3. Username Policy">
          <p>Usernames must be at least 6 characters long and must not impersonate or infringe on the rights of others. We reserve the right to reject or remove usernames that are offensive or misleading.</p>
        </Section>

        <Section title="4. Credits and Payments">
          <p>Our grading services require credits, which can be purchased through the platform. Credits are non-transferable and non-refundable, except where required by law.</p>
          <p>We use third-party payment processors (e.g., Stripe) to handle transactions securely. By purchasing credits, you agree to their terms and privacy policies.</p>
        </Section>

        <Section title="5. Image Uploads and Submissions">
          <p>You may submit card images to be reviewed and graded. You retain ownership of your uploaded content, but you grant us a non-exclusive, royalty-free license to use, display, and analyze your submissions solely for the purpose of providing our services.</p>
          <p>You must not upload content that:</p>
          <ul className="pl-6 list-disc mt-2 leading-relaxed">
            <li>Violates any copyright or intellectual property rights</li>
            <li>Contains harmful, illegal, or offensive material</li>
            <li>Attempts to bypass our credit or grading system</li>
          </ul>
        </Section>

        <Section title="6. Grading Disclaimer">
          <p>All grading results are subjective opinions based on our internal standards. We do not guarantee accuracy, value, or resale potential. Our grades are for informational purposes only and are not recognized by third-party authentication companies.</p>
          <p>We are not liable for decisions you make based on our grading assessments.</p>
        </Section>

        <Section title="7. Termination">
          <p>We may suspend or terminate your access to the platform at any time, with or without notice, if you violate these Terms or abuse the service.</p>
          <p>You may also delete your account at any time by contacting support.</p>
        </Section>

        <Section title="8. Limitation of Liability">
          <p>To the maximum extent permitted by law, whatgradewillitget.com is not liable for any indirect, incidental, or consequential damages resulting from your use of or inability to use the platform.</p>
          <p>Our total liability will not exceed the amount you paid to us in the past 12 months.</p>
        </Section>

        <Section title="9. Changes to These Terms">
          <p>We may update these Terms at any time. If we make material changes, we will notify you through the platform. Continued use after changes means you accept the new Terms.</p>
        </Section>

        <Section title="10. Contact">
          <p>If you have questions about these Terms, please contact us at:</p>
          <strong>chance@whatgradewillitget.com</strong>
        </Section>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold mb-2">{title}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);

export default TermsOfService;
